export default __webpack_public_path__ + "static/media/apple-touch-icon-76x76.a1ff533f.png";